import { initialCirclesState } from 'redux/initialState';
import { status } from 'constants/general';

import circlesActionTypes from './action-types';

const circlesReducer = (state = initialCirclesState, { type, payload }) => {
  switch (type) {
    case circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES:
      return {
        ...state,
        closedCirclesList: {
          status: status.FETCHING,
        },
      };

    case circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES_SUCCESS:
      return {
        ...state,
        closedCirclesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case circlesActionTypes.FETCH_PENDING_CLOSED_CIRCLES_FAIL:
      return {
        ...state,
        closedCirclesList: {
          status: status.FAIL,
        },
      };

    case circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION:
      return {
        ...state,
        changeClosedCircleStatus: {
          status: status.FETCHING,
        },
      };

    case circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_SUCCESS:
      return {
        ...state,
        changeClosedCircleStatus: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case circlesActionTypes.FETCH_CHANGE_CIRCLE_STATUS_SUBMISSION_FAIL:
      return {
        ...state,
        changeClosedCircleStatus: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default circlesReducer;
